import Cookies from '../libs/tomcat-cookies.js';

function getLocale() {
	const locale = Cookies.get('locale');
	return locale && locale.replace('_', '-');
}

export { getLocale };



// WEBPACK FOOTER //
// ./mobile-core/src/libs/locale.js